import { useMutation } from 'react-query';
import { emailMessageRequest } from 'src/models/CRM';
import { postSmsMessage } from 'src/services/CRM/customers';

export default function useSendSms() {
  return useMutation((data: emailMessageRequest) => postSmsMessage(data), {});
}
